export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-iconfont/index.js